import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { OFFER_SELLERS_MAP_VALUE_TO_LABEL } from './constants';

export const offerSellerTypeTagsManager = createTermsTagsManager({
  jsonQueryKey: 'offer_seller_type',
  mapValueToLabel: OFFER_SELLERS_MAP_VALUE_TO_LABEL,
  id: 'offerSellerTypes',
});
